import request from '@/utils/requestLogin'

const state = {
  infoNotifications: JSON.parse(sessionStorage.getItem('infoNotifications')) || [],
}
const getters = {
  infoNotifications: (state) => state.infoNotifications,
}
const actions = {
  loadNotifications({ commit, dispatch }) {
    return request({
      url: '/error-notifications',
      method: 'get',
    }).then((resp) => {
      const Errors = resp.notifications
      commit('SET_Notifications', Errors)
    })
  },

}
const mutations = {
  SET_Notifications(state, payload) {
    state.infoNotifications = payload
    sessionStorage.setItem('infoNotifications', JSON.stringify(payload))
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
